// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__CTG9V","Navcontainer":"Layout_Navcontainer__+PQBh","nav-hide":"Layout_nav-hide__ro8ry","main-content":"Layout_main-content__3e7TG"};